import React, { useState, useEffect, useRef } from "react";
import Widgets from "../../Widgets";
import "../manageClinic/AddDocNew.css";
import Icons from "../../Assets/Icons";
import { t } from "../../Utils/translate";
import validator from "validator";
import toast from "react-hot-toast";
import { phone } from "phone";
import { getLanguage, getAllDepartment, getHospitalPfp, uploadMedia, editDoctor } from "../../modules/AddDoctor/AddDoctorThunk";
import { resetUploadMedia, resetEditDoc } from "../../modules/AddDoctor/AddDoctorSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

const EditDocNew = ({ onClose, doctorInfo, isLangEn }) => {
  const dispatch = useDispatch();
  const { getLangSuccess, getLangErr, getAllDepErr, getAllDepSuccess, getHospitalPfpSuccess, getHospitalPfpErr, uploadMediaSuccess, uploadMediaErr, editDocErr, editDocSuccess } = useSelector(
    (state) => state.addDoctor,
  );
  const fileInputRef = useRef(null);
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const [formData, setFormData] = useState({
    fullNameVn: doctorInfo?.name?.vi,
    fullNameEn: doctorInfo?.name?.en,
    email: doctorInfo?.email,
    phoneNumber: doctorInfo?.phoneNumber,
    countryCode: doctorInfo?.countryCode,
    qualificationEn: doctorInfo?.qualification?.en,
    qualificationVn: doctorInfo?.qualification?.vi,
    descriptionEn: doctorInfo?.description?.en,
    descriptionVn: doctorInfo?.description?.vi,
    docId: doctorInfo?.employeeID,
    gender: doctorInfo?.gender,
    descriptionUrl: doctorInfo?.descriptionUrl,
    descriptionUrlVi: doctorInfo?.descriptionUrlVi,
  });


  const [pfpImg, setPfpImg] = useState(doctorInfo?.profilePic || null);

  const newLang = doctorInfo?.languages.map((i, idx) => ({
    id: i?._id,
    value: i?._id,
    label: isLangEn ? i?.name?.en : i?.name?.vi,
  }));

  const [dropdowns, setDropdowns] = useState({
    localization: { value: "English", label: "English" },
    language: newLang,
    department: { label: doctorInfo?.departmentList[0]?.departmentName?.en, value: doctorInfo?.departmentList[0]?._id },
    grade: { label: doctorInfo?.grade, value: doctorInfo?.grade },
    workExp: { label: doctorInfo?.workExperience, value: doctorInfo?.workExperience },
  });

  const [languageList, setLanguageList] = useState([{ value: null, label: null }]);
  const [departmentList, setDepartmentList] = useState([{ value: null, label: null }]);
  const [hospitalOpenHrs, setHospitalOpenHrs] = useState({});

  const [schedule, setSchedule] = useState(
    daysOfWeek.map((day) => {
      const daySpec = doctorInfo?.openingHoursSpecification.find((spec) => spec.dayOfWeek.toLowerCase() === day.toLowerCase());

      if (daySpec && daySpec.sessions.length > 0) {
        const { opens, closes } = daySpec.sessions[0];
        return {
          day,
          isOpen: true,
          startTime: moment(opens, "HH:mm"),
          endTime: moment(closes, "HH:mm"),
        };
      }

      return {
        day,
        isOpen: false,
        startTime: null,
        endTime: null,
      };
    }),
  );

  const handleCheckboxChange = (index) => {
    setSchedule((prev) => prev.map((item, i) => (i === index ? { ...item, isOpen: !item.isOpen } : item)));
  };

  const handleTimeChange = (index, type, time) => {
    setSchedule((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              ...item,
              [type]: type === "startTime" && time.isAfter(item.endTime) ? item.endTime : time,
            }
          : item,
      ),
    );
  };

  useEffect(() => {
    if (!getLangSuccess && getLangSuccess?.status !== "success") {
      dispatch(getLanguage());
    }
    dispatch(getAllDepartment());
    dispatch(getHospitalPfp());
  }, []);

  useEffect(() => {
    if (getLangErr) {
      toast.error(getLangErr);
    }
    if (getLangSuccess && getLangSuccess.status === "success") {
      const languages = getLangSuccess.data.languages.map((language) => ({
        value: language._id,
        label: language.name,
      }));
      setLanguageList(languages);
    }
  }, [getLangSuccess, getLangErr]);

  useEffect(() => {
    if (getAllDepErr) {
      toast.error(getAllDepErr);
    }
    if (getAllDepSuccess && getAllDepSuccess.status === "success") {
      const dep = getAllDepSuccess.data.departments.map((i) => ({
        value: i._id,
        label: i.departmentName,
      }));
      setDepartmentList(dep);
    }
  }, [getAllDepErr, getAllDepSuccess]);

  useEffect(() => {
    if (getHospitalPfpErr) {
      toast.error(getHospitalPfpErr);
    }
    if (getHospitalPfpSuccess && getHospitalPfpSuccess.status === "success") {
      const hospitalHoursData = getHospitalPfpSuccess.data.hospital?.openingHoursSpecification;

      let hospitalHoursMap = {};
      hospitalHoursData.forEach((item) => {
        hospitalHoursMap[item.dayOfWeek] = {
          opens: item.opens ? moment(item.opens, "HH:mm") : null,
          closes: item.closes ? moment(item.closes, "HH:mm") : null,
        };
      });

      setHospitalOpenHrs(hospitalHoursMap);
    }
  }, [getHospitalPfpSuccess, getHospitalPfpErr]);

  useEffect(() => {
    if (uploadMediaErr) {
      toast.error(uploadMediaErr);
    }
    if (uploadMediaSuccess && uploadMediaSuccess.status === "success") {
      setPfpImg(uploadMediaSuccess.data.urls[0]);
    }
    dispatch(resetUploadMedia());
  }, [uploadMediaSuccess, uploadMediaErr]);

  useEffect(() => {
    if (editDocErr) {
      toast.error(editDocErr);
    }
    if (editDocSuccess && editDocSuccess.status === "success") {
      toast.success(t("doctorEditedSuccess"));
      onClose(false);
    }
    dispatch(resetEditDoc());
  }, [editDocErr, editDocSuccess]);

  const options = [
    { value: "English", label: "English" },
    { value: "Vietnamese", label: "Vietnamese" },
  ];
  const gradeList = [
    { label: "00", value: "00" },
    { label: "01", value: "01" },
    { label: "02", value: "02" },
    { label: "03", value: "03" },
    { label: "04", value: "04" },
    { label: "05", value: "05" },
    { label: "06", value: "06" },
    { label: "07", value: "07" },
    { label: "08", value: "08" },
    { label: "09", value: "09" },
    { label: "10", value: "10" },
  ];
  const num = 1;
  const yearList = Array.from({ length: 100 }, (_, i) => {
    const year = num + i;
    return { label: year, value: year };
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let trimmedValue = value.trimStart();

    if (["fullNameVn", "fullNameEn"].includes(name)) {
      if (/\d/.test(trimmedValue)) return;
    }
    if (["qualificationEn", "qualificationVn", "descriptionEn", "descriptionVn"].includes(name)) {
      trimmedValue = trimmedValue.slice(0, 100);
    } else {
      trimmedValue = trimmedValue.slice(0, 255);
    }
    if (["phoneNumber", "docId"].includes(name)) {
      if (!/^\d*$/.test(trimmedValue)) return;
    }
    if (name === "docId" && trimmedValue.length > 4) return;

    setFormData((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));
  };

  const handleDropdownChange = (dropdownName, selectedOption) => {
    setDropdowns((prev) => ({
      ...prev,
      [dropdownName]: selectedOption,
    }));
  };

  const handlePhoneChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      ["phoneNumber"]: e.phoneNumber,
      ["countryCode"]: e.countryCode,
    }));
  };

  const handleLanguageChange = (id, selectedOption) => {
    setDropdowns((prev) => ({
      ...prev,
      language: prev.language.map((lang) => (lang.id === id ? { ...lang, ...selectedOption } : lang)),
    }));
  };

  const handleAddLanguage = () => {
    const lastLanguage = dropdowns.language[dropdowns.language.length - 1];
    if (lastLanguage && lastLanguage.value) {
      setDropdowns((prev) => ({
        ...prev,
        language: [...prev.language, { id: Date.now(), value: null, label: null }],
      }));
    }
  };

  const handleAddPfp = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const processFiles = (files) => {
    const validImageTypes = ["image/jpeg", "image/png", "image/webp"];
    const imageFiles = files.filter((file) => validImageTypes.includes(file.type));

    if (imageFiles.length > 0) {
      dispatch(uploadMedia({ files: imageFiles }));
    } else {
      toast.error(t("warnImg"));
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    const validFiles = files.filter((file) => {
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB > 0 && fileSizeKB <= 2048) {
        return true;
      } else {
        if (fileSizeKB > 2048) {
          toast.error(t("imageSizeWarn"));
        } else {
          toast.error(t("selectValidImage"));
        }
        return false;
      }
    });

    if (validFiles.length > 0) {
      processFiles(validFiles);
    }
    e.target.value = "";
  };

  const getFilteredOptions = (currentId) => {
    const selectedValues = dropdowns.language.filter((lang) => lang.id !== currentId && lang.value).map((lang) => lang.value);
    return languageList.filter((option) => !selectedValues.includes(option.value));
  };

  const handleAddDoc = (e) => {
    e.preventDefault();
    const openingHoursSpecification = schedule.map((day) => ({
      dayOfWeek: day.day,
      sessions:
        day.isOpen && day.startTime && day.endTime
          ? [
              {
                opens: day.startTime.format("HH:mm"),
                closes: day.endTime.format("HH:mm"),
              },
            ]
          : [],
    }));

    if (!formData.fullNameEn && dropdowns.localization.value === "Vietnamese") {
      toast.error(t("errChngLclNameEn"));
      return;
    }
    if (!formData.fullNameEn) {
      toast.error(t("errFullNameEng"));
      return;
    }
    if (formData.fullNameEn.trim().length < 3) {
      toast.error(t("errNameEngLnth"));
      return;
    }
    if (!formData.fullNameVn && dropdowns.localization.value === "English") {
      toast.error(t("errChngLclNameVn"));
      return;
    }
    if (!formData.fullNameVn) {
      toast.error(t("errNameVn"));
      return;
    }
    if (!formData.email) {
      toast.error(t("errEntEmail"));
      return;
    }
    if (!validator.isEmail(formData.email)) {
      toast.error(t("entValidEmail"));
      return;
    }
    if (!formData.phoneNumber) {
      toast.error(t("errEntPhone"));
      return;
    }
    const fullPhone = `+${formData.countryCode}${formData.phoneNumber}`;
    const phoneResult = phone(fullPhone);
    if (!phoneResult.isValid) {
      toast.error(t("errEntValidPhone"));
      return;
    }
    if (!formData.qualificationEn && dropdowns.localization.value === "Vietnamese") {
      toast.error(t("errEntQualifEn"));
      return;
    }
    if (!formData.qualificationEn) {
      toast.error(t("errEntQualif"));
      return;
    }
    if (!formData.qualificationVn && dropdowns.localization.value === "English") {
      toast.error(t("errEntQualifVnChg"));
      return;
    }
    if (!formData.qualificationVn) {
      toast.error(t("errEntQualifVn"));
      return;
    }
    if (formData.descriptionEn.length === 0 && dropdowns.localization.value === "Vietnamese" && formData.descriptionVn.length > 0) {
      toast.error(t("entDesInEn"));
      return;
    }
    if (formData.descriptionEn.length === 0 && formData.descriptionVn.length > 0) {
      toast.error(t("entDesErr"));
      return;
    }
    if (formData.descriptionEn.length > 0 && dropdowns.localization.value === "English" && formData.descriptionVn.length === 0) {
      toast.error(t("entDesInVi"));
      return;
    }
    if (formData.descriptionEn.length > 0 && formData.descriptionVn.length === 0) {
      toast.error(t("entDesErr"));
      return;
    }
    // if (formData.descriptionEn.length > 0 && formData.descriptionUrl.length === 0) {
    //   toast.error(t("plsentDesUrl"));
    //   return;
    // }
    const isValidURL = (string) => {
      const res = string.match(/(https?:\/\/[^\s]+)/g);
      return res !== null;
    };

        if (formData.descriptionUrl.length > 0 && formData.descriptionUrlVi.length === 0) {
   if (dropdowns.localization.value === "English") {
    toast.error(t("desUrlViRequiredSwitch")); 
     } else {
    toast.error(t("desUrlViRequired")); 
     }
     return;
    }

    if (formData.descriptionUrlVi.length > 0 && formData.descriptionUrl.length === 0) {
      if (dropdowns.localization.value === "Vietnamese") {
        toast.error(t("desUrlEnRequiredSwitch")); 
      } else {
        toast.error(t("desUrlEnRequired")); 
      }
      return;
    }

    if (formData.descriptionUrl.length > 0 && !isValidURL(formData.descriptionUrl)) {
      toast.error(t("desUrlInvalid"));
      return;
    }
    if (!formData.gender) {
      toast.error(t("errSelGender"));
      return;
    }
    let selLang = dropdowns.language[dropdowns.language.length - 1];
    if (!selLang.value) {
      toast.error(t("errSelLang"));
      return;
    }
    if (!dropdowns.department?.value) {
      toast.error(t("errSelDep"));
      return;
    }
    if (!dropdowns.grade?.value) {
      toast.error(t("errSelGrade"));
      return;
    }
    if (!formData.docId) {
      toast.error(t("errEntDocId"));
      return;
    }
    if (formData.docId === "0000") {
      toast.error(t("errDocId"));
      return;
    }

    if (!dropdowns.workExp?.value) {
      toast.error(t("errSelWorkexp"));
      return;
    }
    for (let i = 0; i < schedule.length; i++) {
      const daySchedule = schedule[i];
      if (daySchedule.isOpen) {
        const dayNameLower = daySchedule.day.toLowerCase();
        if (!daySchedule.startTime) {
          toast.error(t(`entStartTime`, { day: dayNameLower }));
          return;
        }
        if (!daySchedule.endTime) {
          toast.error(t("entEndTime", { day: dayNameLower }));
          return;
        }
        if (daySchedule.startTime.clone().add(10, "minutes").isAfter(daySchedule.endTime)) {
          toast.error(t("errTimeDiff", { day: dayNameLower }));
          return;
        }
      }
    }

    const newLang = dropdowns.language.map((i) => i.value);

    const sendData = {
      phoneNumber: formData.phoneNumber,
      countryCode: formData.countryCode,
      email: formData.email,
      name: {
        en: formData.fullNameEn,
        vi: formData.fullNameVn,
      },
      description: {
        en: formData.descriptionEn,
        vi: formData.descriptionVn,
      },
      gender: (formData.gender?.en || formData.gender) === "Male" ? { en: "Male", vi: "Nam" } : { en: "Female", vi: "Nữ" },
      workExperience: dropdowns.workExp.value,
      languages: newLang,
      openingHours: ["Mo-Fr 09:00-17:00"],
      openingHoursSpecification: openingHoursSpecification,
      departmentList: [dropdowns.department.value],
      profilePic: pfpImg ? pfpImg?.replace(/ /g, "%20") : null,
      qualification: {
        en: formData.qualificationEn,
        vi: formData.qualificationVn,
      },
      grade: dropdowns.grade.value,
      employeeID: formData.docId,
      descriptionUrl: formData.descriptionUrl,
      descriptionUrlVi: formData.descriptionUrlVi,
    };

    dispatch(editDoctor({ sendData, _id: doctorInfo._id }));
  };

  return (
    <div>
      <div className="nd-profile">
        <div className="d-flex justify-content-center nd-add-pfp">
          <div className="nd-add-pfp-new">
            <img className="nd-pfpicon" src={pfpImg || Icons.PfpIcon} alt="pfpicon" onClick={handleAddPfp} />
            <img className="nd-edit-pfp" src={Icons.EditIcon} alt="EditIcon" onClick={handleAddPfp} />
            <input ref={fileInputRef} type="file" accept="image/*" className="file-input-card" onChange={handleImageChange} />
          </div>
        </div>
        <div className="nd-localize">
          <label className="nad-lable">
            {t("localization")}
            <span className="astrik">*</span>
          </label>
          <Widgets.NewSelDropdown options={options} placeholder={"selGrpName"} noMargin selectedValue={dropdowns.localization} onChange={(i) => handleDropdownChange("localization", i)} />
        </div>
      </div>

      <div className="nad-row">
        <div className="nd-localize">
          {dropdowns.localization?.value === "English" && (
            <>
              <label className="nad-lable">
                {t("fullNameEn")}
                <span className="astrik">*</span>
              </label>
              <input className="nd-inputs" type="text" name="fullNameEn" placeholder={t("entFullNameEng")} value={formData.fullNameEn} onChange={handleInputChange} />
            </>
          )}
          {dropdowns.localization?.value === "Vietnamese" && (
            <>
              <label className="nad-lable">
                {t("fullNameVn")}
                <span className="astrik">*</span>
              </label>
              <input className="nd-inputs" type="text" name="fullNameVn" placeholder={t("entFullNameVn")} value={formData.fullNameVn} onChange={handleInputChange} />
            </>
          )}
        </div>
        <div className="nd-localize">
          <label className="nad-lable">
            {t("email")}
            <span className="astrik">*</span>
          </label>
          <input className="nd-inputs" type="text" name="email" placeholder={t("entEmail")} value={formData.email} onChange={handleInputChange} disabled={true} />
        </div>
      </div>

      <div className="nad-row">
        <div className="nd-localize">
          <label className="nad-lable">
            {t("phnNum")}
            <span className="astrik">*</span>
          </label>
          <div className="pdl-hn">
            <Widgets.PhoneNumber onChange={handlePhoneChange} cc={formData?.countryCode} phoneNum={formData?.phoneNumber} />
          </div>
        </div>
        <div className="nd-localize">
          {dropdowns.localization?.value === "English" && (
            <>
              <label className="nad-lable">
                {t("qualificationEn")}
                <span className="astrik">*</span>
              </label>
              <input className="nd-inputs" type="text" name="qualificationEn" placeholder={t("entQualification")} value={formData.qualificationEn} onChange={handleInputChange} />
            </>
          )}
          {dropdowns.localization?.value === "Vietnamese" && (
            <>
              <label className="nad-lable">
                {t("qualificationVn")}
                <span className="astrik">*</span>
              </label>
              <input className="nd-inputs" type="text" name="qualificationVn" placeholder={t("entQualification")} value={formData.qualificationVn} onChange={handleInputChange} />
            </>
          )}
        </div>
      </div>

      <div className="nad-row">
        <div className="nd-localize full">
          {dropdowns.localization?.value === "English" && (
            <>
              <label className="nad-lable">{t("desEn")}</label>
              <input className="nd-inputs" type="text" name="descriptionEn" placeholder={t("entDesEng")} value={formData.descriptionEn} onChange={handleInputChange} />
            </>
          )}
          {dropdowns.localization?.value === "Vietnamese" && (
            <>
              <label className="nad-lable">{t("desVn")}</label>
              <input className="nd-inputs" type="text" name="descriptionVn" placeholder={t("entDesVn")} value={formData.descriptionVn} onChange={handleInputChange} />
            </>
          )}
        </div>
      </div>
      <div className="nad-row">
        <div className="nd-localize full">
           {dropdowns.localization?.value === "English" ? (<>
             <label className="nad-lable">{t("desUrlEn")}</label>
          <input className="nd-inputs" type="text" name="descriptionUrl" placeholder={t("entDesUrl")} value={formData.descriptionUrl} onChange={handleInputChange} />
           </>):
           (<>
           <label className="nad-lable">{t("desUrlVi")}</label>
          <input className="nd-inputs" type="text" name="descriptionUrlVi" placeholder={t("entDesUrl")} value={formData.descriptionUrlVi} onChange={handleInputChange} />
           </>)}
        
        </div>
      </div>
      <div className="nad-row">
        <div className="nd-localize full">
          <label className="nad-lable">
            {t("department")}
            <span className="astrik">*</span>
          </label>
          <Widgets.NewSelDropdown
            options={departmentList}
            placeholder={"seldepartment"}
            noMargin
            selectedValue={dropdowns.department}
            onChange={(i) => handleDropdownChange("department", i)}
            disableTruncat={true}
          />
        </div>
      </div>

      <div className="nad-row">
        <div className="nd-localize">
          <label className="nad-lable">
            {t("language")}
            <span className="astrik">*</span>
          </label>

          {dropdowns.language.map((lang) => (
            <div key={lang.id} style={{ position: "relative" }}>
              <Widgets.NewSelDropdown
                options={getFilteredOptions(lang.id)}
                placeholder="Select language"
                noMargin
                selectedValue={lang}
                onChange={(selectedOption) => handleLanguageChange(lang.id, selectedOption)}
              />
              {dropdowns.language.length > 1 && (
                <button
                  style={{ marginLeft: "5px" }}
                  onClick={() =>
                    setDropdowns((prev) => ({
                      ...prev,
                      language: prev.language.filter((item) => item.id !== lang.id),
                    }))
                  }
                >
                  <img className="nad-lang-del" src={Icons.Delicon} alt="del" />
                </button>
              )}
            </div>
          ))}

          {dropdowns.language[dropdowns.language.length - 1].value && dropdowns.language.length < 6 && (
            <div className="nad-add-line" onClick={handleAddLanguage}>
              <img className="nad-lang-add" src={Icons.Plusicon} alt="plus" />
            </div>
          )}
        </div>
        <div className="nd-localize">
          <div>
            <label className="nad-lable">
              {t("gender")}
              <span className="astrik">*</span>
            </label>{" "}
            <div className="nad-gender">
              <div className="nad-radio">
                <input type="radio" id="Male" name="gender" value="Male" checked={(formData.gender?.en || formData.gender) === "Male"} onChange={handleInputChange} />
                <label htmlFor="Male">{t("male")}</label>
              </div>
              <div className="nad-radio">
                <input type="radio" id="Female" name="gender" value="Female" checked={(formData.gender?.en || formData.gender) === "Female"} onChange={handleInputChange} />
                <label htmlFor="Female">{t("female")}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="nad-row">
        <div className="nd-localize">
          <label className="nad-lable">
            {t("docId")}
            <span className="astrik">*</span>
          </label>
          <input className="nd-inputs" type="text" name="docId" placeholder={t("entdocId")} value={formData.docId} onChange={handleInputChange} disabled={true} />
        </div>
        <div className="nd-localize">
          <label className="nad-lable">
            {t("grade")}
            <span className="astrik">*</span>
          </label>
          <Widgets.NewSelDropdown options={gradeList} placeholder={"selgrade"} noMargin selectedValue={dropdowns.grade} onChange={(i) => handleDropdownChange("grade", i)} />
        </div>
      </div>

      <div className="nad-row">
        <div className="nd-localize">
          <label className="nad-lable">
            {t("workExp")}
            <span className="astrik">*</span>
          </label>
          <Widgets.NewSelDropdown options={yearList} placeholder={"entworkExp"} noMargin selectedValue={dropdowns.workExp} onChange={(i) => handleDropdownChange("workExp", i)} />
        </div>
      </div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
          <div className="nad-schedule">{t("weekScheTable")}</div>

          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>{t("day")}</TableCell>
                <TableCell>{t("startTime")} </TableCell>
                <TableCell>{t("endTime")} </TableCell>
                <TableCell>{t("hospitalTime")} </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {schedule.map((item, index) => {
                const hospitalTiming = hospitalOpenHrs[item.day];
                const hospitalOpens = hospitalTiming?.opens;
                const hospitalCloses = hospitalTiming?.closes;
                return (
                  <TableRow key={item.day}>
                    <TableCell>
                      <Checkbox checked={item.isOpen} onChange={() => handleCheckboxChange(index)} disabled={!hospitalOpens || !hospitalCloses} />
                    </TableCell>
                    <TableCell>{t(item.day)}</TableCell>
                    <TableCell>
                      <TimePicker
                        value={item.startTime}
                        inputFormat="HH:mm"
                        ampm={false}
                        disabled={!item.isOpen}
                        minTime={hospitalOpens || null}
                        maxTime={hospitalCloses ? hospitalCloses.clone().subtract(10, "minutes") : null}
                        onChange={(time) => handleTimeChange(index, "startTime", time)}
                      />
                    </TableCell>
                    <TableCell>
                      <TimePicker
                        value={item.endTime}
                        inputFormat="HH:mm"
                        ampm={false}
                        disabled={!item.isOpen}
                        minTime={item.startTime ? item.startTime.clone().add(10, "minutes") : hospitalOpens ? hospitalOpens.clone().add(10, "minutes") : null}
                        maxTime={hospitalCloses || null}
                        onChange={(time) => handleTimeChange(index, "endTime", time)}
                      />
                    </TableCell>
                    <TableCell>{hospitalOpens && hospitalCloses ? `${hospitalOpens.format("HH:mm")} - ${hospitalCloses.format("HH:mm")}` : t("closed")}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </LocalizationProvider>
      <div className="nad-btns-sec">
        <div
          className="nad-cancel-btn"
          onClick={() => {
            onClose(false);
          }}
        >
          {t("cancel")}
        </div>
        <div onClick={handleAddDoc} className="nad-submit-btn">
          {t("submit")}
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default EditDocNew;